<template>
  <v-sheet
    height="60px"
    width="100%"
    color="muted"
    class="d-flex align-center rounded-lg foreground--text text-subtitle-1">
    <v-container
      fluid>
      <v-row
        class="align-center">
        <v-col
          cols="1"
          class="primary--text">
          Protocolo
        </v-col>
        <v-col
          class="d-flex flex-row primary--text"
          cols="4">
          Nome do arquivo
        </v-col>
        <v-col
          cols="3"
          class="primary--text">
          Grupo Financeiro
        </v-col>
        <v-col
          cols="3"
          class="primary--text">
          Operadora
        </v-col>
        <v-col
          class="d-flex justify-end primary--text"
          cols="1">
          Ações
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>
<script>
export default {
  name: "ConferenceHeader"
}
</script>
